import { html } from '@microsoft/fast-element';

export const BuyerDashboardKnowledgeBlock = html`
  <div class="knowledge-block-modal-content">
    <h1 class="title ">Overview</h1>
    <p>
      The Dashboard page provides an overview of all activity that has been undertaken, as well as
      the management and listing of RFQs (Bids). Users can also monitor and track Projects and
      Contracts (Offers) of interest.
    </p>

    <h1 class="title ">Buyer Dashboard</h1>

    <p>
      The Buyer Dashboard allows for the effective monitoring of trading activity through the key
      stages of the end-to-end workflow captured in the following tabs: Trading Activity, Active
      RFQs, Inactive RFQ’s, Negotiations, Executed and Terminated.
    </p>
    <p>
      Hovering over the ? icon on each tab will provide a brief description of the data captured in
      each tab.
    </p>

    <p>
      Selection of a Buyer Dashboard tab will display any relevant corresponding activity for that
      tab.
    </p>

    <p class="item">Managing RFQs (Bids)</p>

    <p>
      RFQs (Bids) can be added (listed) using the + New RFQ button located in the top right corner
      of the panel. Listed RFQs (Bids) can be modified, delisted, or deleted as required, using the
      appropriate buttons in the Action column for the relevant RFQ (Bid) record.
    </p>
    <p>
      RFQs (Bids) cannot be deleted if they are under negotiation in the Engagements Module or
      Contracting Module. To delete such a RFQ (Bid) record, all negotiations associated with that
      RFQ (Bid) in the Engagements Module need to be rejected and all negotiations in the
      Contracting Module need to be terminated before such deletion can occur.
    </p>
    <p class="item">Action Buttons</p>
    <p>
      Using the Action Button (indicating the current Engagement status) in the Trading Activity tab
      will take the user to the Active Engagement negotiation for the selected negotiation in the
      Engagements Module.
    </p>
    <p>
      Using the Action Button (indicating the current Negotiation status) in the Negotiations tab
      will open the Contracting Module or Execution modal (as appropriate) for the selected
      negotiation.
    </p>
    <p>
      Using the Action Button (indicating the Transaction Status) in the Executed tab will open the
      Contracting Module for those Transactions subject to the RFQ Method of Execution where the
      Executed Transaction Confirmation can be viewed. For the Auto Execution Method, the Execution
      Modal will open displaying the Execution Summary when the Action button is selected.
    </p>

    <h1 class="title">Watchlist</h1>

    <p>
      The Watchlist is in the upper right quadrant of the Dashboard page and allows Projects and
      Contracts (Offers) that are of interest to be tracked and monitored.
    </p>

    <p>
      Select the star icon for a Contract (Offer) in Seller Interest, on the Analytics Comparison
      page, or the Project Metrics Page to add a Contract (Offer) or Project to the Watchlist. To
      remove the selection, deselect the star icon in the Watchlist or in the aforementioned
      locations.
    </p>

    <p>
      Selecting the Project Name or an Offer’s Unique ID hyperlink in the Watchlist will display the
      Project Overview and Project Metrics page where financial and carbon analysis can be
      undertaken.
    </p>
    <h1 class="title">Seller Interest</h1>

    <p>
      Seller Interest is in the lower left quadrant of the Dashboard page and displays Offers that
      match the criteria set forth in the RFQ (Bid) records that a Buyer has listed.
    </p>

    <p>
      This section can be expanded by selecting the Expand Contracts (Offers) button, allowing the
      user to see more Contract (Offer) data, and can be contracted again by selecting the Contract
      Contracts button.
    </p>

    <p>
      The Contracts (Offers) displayed in Seller Interest can be filtered further by selecting the
      relevant RFQ (Bid) in the Filter by RFQ field. This action will filter the Contract (Offer)
      data to display those Contracts (Offers) that match the criteria of the selected RFQ (Bid).
    </p>

    <h1 class="title ">Market Index Performance Chart</h1>

    <p>
      The Market Index Performance Chart is in the lower right quadrant of the Dashboard page and
      displays Historical Market Performance data including hub prices, generation-weighted
      performance, and carbon metrics.
    </p>

    <p>
      The chart displays the first/ top RFQ (Bid) record in the Recent Activity tab as a default.
    </p>
    <p>
      If a different RFQ (Bid) record is selected in the Recent Activity tab of the Buyer Dashboard,
      or a different Contract (Offer) record is selected in the Watchlist or Seller Interest, then
      the chart will display the data associated with the selected Contract (Offer) record.
    </p>

    <p>
      Hovering over the graph will display a tooltip with the relevant metrics data for that point
      in time.
    </p>
  </div>
`;
